export const usersApiQueryKeys = {
  all: () => ['users'] as const,
  byId: (userId: string) => ['users', userId] as const,
  byEmail: (email: string) => ['users', email] as const,
};
